import { render, staticRenderFns } from "./AddressView.vue?vue&type=template&id=637c9a26&scoped=true"
import script from "./AddressView.vue?vue&type=script&lang=js"
export * from "./AddressView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637c9a26",
  null
  
)

export default component.exports